import { createRouter, createWebHashHistory } from 'vue-router'
import MonitorDashboard from '../views/MonitorDashboard.vue'
import Login from '../views/Login.vue'
import PredictionDashboard from '../views/PredictionDashboard.vue'
import Reports from '../views/Reports.vue'
import ReportPdf from '../views/ReportPdf.vue'
import Versions from '@/views/Versions.vue'

//routes -screens for the e.m.s software

const routes = [

  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/Reports',
    name: 'Reports',
    component: Reports,
    meta: {requiresAuth: true}
  },
  {
    path: '/Versions',
    name: 'Versions',
    component: Versions,
    meta: {requiresAuth: true}
  },
  {
    path: '/ReportPdf',
    name: 'ReportPdf',
    component: ReportPdf,
    meta: {requiresAuth: true}
  },
  {
    path: '/PrintPdf',
    name: 'PrintPdf',
    component: () => import('../views/PrintPdf.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/monitordashboard',
    name: 'MonitorDashboard',
    component: () => import( '../views/MonitorDashboard.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/monitordetail/:id?',
    name: 'MonitorDetail',
    component: () => import( '../views/MonitorDetail.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/predictiondashboard',
    name: 'predictiondashboard',
    component: () => import('../views/PredictionDashboard.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/predictiondetail/:id?',
    name: 'PredictionDetail',
    component: () => import('../views/PredictionDetail.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/administration-dashboard',
    name: 'administrationdashboard',
    component: () => import('../views/Administrationdashboard.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound.vue')
  },
    {
    path: '/exceldownload',
    name: 'ExcelDownload',

    component: () => import('../views/ExcelDownload.vue')
  },
]




const router = createRouter({
  history: createWebHashHistory(),
  routes
})



router.beforeEach((to, from, next) => {
  let hasToken = Boolean(sessionStorage.getItem('act'));;
 if (!hasToken && to.meta.requiresAuth) {
  next('/');
}else{
  next();
}
 

 })



export default router
